import { reduxForm } from 'redux-form'
import { compose, withProps } from 'recompose'
import CompatibilityForm from './CompatibilityForm'
import { FORM_NAME } from './constants'
import viewModel from './viewModel'

const withFormData = withProps({ viewModel })

export default compose(
  withFormData,
  reduxForm({ form: FORM_NAME })
)(CompatibilityForm)
